import React, { memo, useCallback, useEffect, useMemo, useRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { Container, Grid, Paper } from "@material-ui/core";
import BaseTextField from "./public/BaseTextField";
import CommentIcon from "@material-ui/icons/Description";
import { inputStyles } from "../styles/styles";
import { useParams } from "react-router-dom/cjs/react-router-dom";

import { Document, Page } from "react-pdf/dist/esm/entry.webpack";

const options = {
  cMapUrl: "/cmaps/",
  standartFontDataUrl: "/standard_fonts/",
};

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function DocumentDialog(props) {
  const [open, setOpen] = React.useState(false);
  const classes = inputStyles();
  const iframeRef = useRef();

  let { uuid } = useParams();

  const [onayBtnDisabled, setOnayBtnDisabled] = React.useState(true);
  const [numPages, setNumPages] = React.useState(1);
  const [pageNumber, setPageNumber] = React.useState(1);
  /*const url = useMemo(() => {
    return {
      url: `${window.ENV.DOCUMENT_BASE_URL}${props.document.documentId}/${props.uuid}`
    };
  });*/

  const onayButtonHandle = useCallback(
    () => setOnayBtnDisabled(false),
    [onayBtnDisabled]
  );

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCheck = () => {
    handleClose();
    props.handleCheck(props.title);
  };

  /*  const handleOnload = () => {
    const viewer = iframeRef.current;
    /*const iframe =
      iframeRef.current &&
      (iframeRef.current.contentDocument ||
        iframeRef.current.contentWindow.document);
    const viewer = iframe.getElementById("viewerContainer");
    if (viewer.scrollTop + viewer.offsetHeight >= viewer.scrollHeight + 2 ) {
      viewerScrollHandler(viewer);
    } else {
      setOnayBtnDisabled(false);
    }
  };
  const viewerScrollHandler = (viewer) => {
    const scrollHandler = (e) => {
      const scrollPosition = viewer.scrollTop + viewer.offsetHeight + 2;
      if (scrollPosition >= viewer.scrollHeight) {
        setOnayBtnDisabled(false);
        viewer.removeEventListener("scroll", scrollHandler, false);
        return ;
      }
    };

    viewer.addEventListener("scroll", scrollHandler);
  };

*/

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setOnayBtnDisabled(false);

    //handleOnload();
  }

  const handleDownload = () => {
    //window.open("data:application/pdf;base64," + props.document.documentId);
    var a = document.createElement("a"); //Create <a>
    a.href = "data:application/pdf;base64," + props.document.documentId; //Image Base64 Goes here
    a.download = props.document.documentName; //File name Here
    a.click(); //Downloaded file
    a.remove();
  };

  const Test = React.memo(({ list }) => {
    return (
      <Document
        file={"data:application/pdf;base64," + props.document.documentId}
        options={options}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        {Array.apply(null, Array(numPages))
          .map((x, i) => i + 1)
          .map((page) => (
            <Page
              key={page}
              pageNumber={page}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          ))}
      </Document>
    );
  });

  const downloadTest = () => {
    if (props.document.documentId) {
      var iOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      var isChrome =
        navigator.userAgent.toLowerCase().indexOf("CriOS") > -1 ||
        navigator.vendor.toLowerCase().indexOf("google") > -1;
      var iOSVersion = [];
      if (iOS) {
        iOSVersion = navigator.userAgent
          .match(/OS [\d_]+/i)[0]
          .substr(3)
          .split("_")
          .map((n) => parseInt(n));
      }
      var attachmentData = props.document.documentId;
      var attachmentName = props.document.documentName + ".pdf";
      var contentType = "application/pdf";

      var binary = atob(attachmentData.replace(/\s/g, ""));
      var len = binary.length;
      var buffer = new ArrayBuffer(len);
      var view = new Uint8Array(buffer);
      for (var i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
      }
      var linkElement = document.createElement("a");
      try {
        var hrefUrl = "";
        var blob = "";
        if (iOS && !isChrome && iOSVersion[0] <= 12) {
          blob = "data:application/pdf;base64," + props.document.documentId;
          hrefUrl = blob;
        } else {
          if (iOS && !isChrome) {
            contentType = "application/octet-stream";
          }
          blob = new Blob([view], { type: contentType });
          hrefUrl = window.URL.createObjectURL(blob);
        }
        linkElement.setAttribute("href", hrefUrl);
        linkElement.setAttribute("target", "_blank");
        if ((iOS && (iOSVersion[0] > 12 || isChrome)) || !iOS) {
          linkElement.setAttribute("download", attachmentName);
        }
        var clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        linkElement.dispatchEvent(clickEvent);
      } catch (ex) {}
    }
  };

  return (
    <div>
      <IconButton aria-label="comments" onClick={handleClickOpen} ref={props.buttonRef}>
        <CommentIcon />
      </IconButton>
      {open && (
        <Dialog onClose={handleClose} open={open} fullWidth>
          <DialogContent
            dividers
            style={{ overflow: "hidden", overflowY: "auto" }}
            ref={iframeRef}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Paper>
                  {<Test />}
                  {/*
                    <object data={convertBase64(
                      `data:application/pdf;base64,${props.document.documentId}`
                    )} >
                      <iframe
                      title={props.title}
                      ref={iframeRef}
                      src={"https://docs.google.com/viewer?&embedded=true"}
                      height="550"
                      width="100%"
                      onLoad={handleOnload}
                    />
                    </object>
                    */}
                </Paper>
                <Grid
                  container
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  item
                  style={{ marginTop: 30 }}
                >
                  {/*<Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    disabled={onayBtnDisabled}
                    href={`data:application/pdf;base64,${props.document.documentId}`}
                    download={props.document.documentName}
                    target="_blank"
                  >
                    İndir
                  </Button>*/}
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    disabled={onayBtnDisabled}
                    onClick={downloadTest}
                  >
                    İndir
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    disabled={onayBtnDisabled}
                    onClick={handleCheck}
                  >
                    Okudum, Onaylıyorum
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
